import React, { useEffect, useState } from 'react';
import "./Timeline.scss"
import { calculateRecordTopPosition } from '../../../helpers/record';


const Timeline = ({ }) => {
	const [ topPosition, setTopPosition ] = useState(0);
	const [ hours, setHours ] = useState(0);
	const [ minutes, setMinutes ] = useState(0);

	useEffect(() => {
		setCurrentTime();
		setInterval(() => {
			setCurrentTime();
		}, 1000);
	}, [])

	const setCurrentTime = () => {
		const date = new Date();
		const h = date.getHours();
		const m = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes();
		setHours(h)
		setMinutes(m)

		setTopPosition(calculateRecordTopPosition(h+':'+m) + 55);
	}

	return (
		<>
		{
			Number(hours) >= 10 && Number(hours) <= 22 &&
			<div className="timeline" style={{top: topPosition+'px'}}>
				<div className="timeline__time left">
					{hours}:{minutes}
				</div>
				<div className="timeline__line"></div>
				<div className="timeline__time right">
					{hours}:{minutes}
				</div>
			</div>
		}
		{/* <div className="expiration-zone" style={{height: 9 + topPosition+'px'}}></div> */}
		</>
	);
};

export default Timeline;
